<template>
    <div>
      <!--面包屑导航区域-->
      <el-breadcrumb separator-class="el-icon-arrow-right" class="bread">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>卖家地址管理</el-breadcrumb-item>
        <el-breadcrumb-item>新增地址</el-breadcrumb-item>
      </el-breadcrumb>
      <!--添加商品表单-->
      <el-form class="form" label-width="100px" :model="form" :ref="form">
        <el-form-item label="商家名">
          <el-input placeholder="请输入商家名" v-model="form.receiverName" style="width: 222px"></el-input>
        </el-form-item>
        <el-form-item label="商家电话">
          <el-input placeholder="请输入商家电话" v-model="form.receiverPhone" minlength="11" maxlength="11" show-word-limit style="width: 222px"></el-input>
        </el-form-item>
        <el-form-item label="商家省份">
          <el-select v-model="form.receiverProvince" @change="selectProvince" placeholder="请选择省份">
            <el-option v-for="province in addressList"  :key="province.name" :label="province.name" :value="province.name">
           </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商家城市">
          <el-select v-model="form.receiverCity" @change="selectCity" placeholder="请选择城市">
            <el-option v-for="city in provinceList" :key="city.name" :label="city.name" :value="city.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商家区/县">
          <el-select v-model="form.receiverDistrict" placeholder="请选择地区">
            <el-option v-for="area in areaList" :key="area" :label="area" :value="area">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商家详细地址">
          <el-input placeholder="请输入商家详细地址" v-model="form.receiverAddress" style="width: 222px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" style="margin-left: 50px">新增地址</el-button>
        </el-form-item>
      </el-form>
    </div>
</template>

<script>
const request = require('./../../http/address')
const addressJson = require('./../../assets/json/address.json')
export default {
  name: 'addAddress',
  mounted () {
    console.log(addressJson)
  },
  data () {
    return {
      addressList: addressJson,
      provinceList: [], // 省份列表
      cityList: [], // 城市表
      areaList: [], // 地区表
      form: { // 表单数据
        receiverAddress: '', // 商家详细地址
        receiverProvince: '', // 商家省份
        receiverCity: '', // 商家城市
        receiverDistrict: '', // 商家地区
        receiverName: '', // 商家姓名
        receiverPhone: ''// 商家电话
      }
    }
  },
  methods: {
    async onSubmit () { // 新增地址
      let data = {
        receiverAddress: this.form.receiverAddress,
        receiverCity: this.form.receiverCity,
        receiverDistrict: this.form.receiverDistrict,
        receiverName: this.form.receiverName,
        receiverPhone: this.form.receiverPhone,
        receiverProvince: this.form.receiverProvince
      }
      let addAddressRes = await request.addAddress(data)
      console.log(addAddressRes)
      if (addAddressRes.data.message === '成功') {
        this.$message({
          message: '新增地址成功',
          type: 'success'
        })
      } else {
        this.$message.error('新增地址失败')
      }
    },
    selectProvince (e) { // 选择省份
      for (let i = 0; i < this.addressList.length; i++) {
        if (this.addressList[i].name === e) {
          this.provinceList = this.addressList[i].city
          break
        }
      }
    },
    selectCity (e) { // 选择城市
      console.log(e)
      console.log(this.provinceList[0].name)
      for (let i = 0; i < this.provinceList.length; i++) {
        if (this.provinceList[i].name === e) {
          this.areaList = this.provinceList[i].area
          break
        }
      }
      console.log(this.areaList)
    }
  }
}
</script>

<style scoped>
.form{
  margin-top: 50px;
}
</style>
